import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import { injectIntl, FormattedMessage } from 'react-intl';
import { FormControl, Button, FormGroup } from 'react-bootstrap';

// Redux
import { connect } from 'react-redux';

//Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Locale
import messages from '../../../locale/jsonMessages';

import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';

//Actions
import { onChangeListingFilter } from '../../../actions/Listing/onChangeListing';
import { closeTransactionModal } from '../../../actions/modalActions';
import { withQuery } from '../../../hoc/withGraphql';

import bt from '../../../components/commonStyle.css';
import s from './ModalFilter.css';

class Listings extends Component {

	constructor(props) {
		super(props);
		this.state = {
			listId: null,
			payoutId: null

		}

	}
	componentDidMount() {
		const { payoutId, listId } = this.props;
		this.setState({ payoutId: payoutId ? payoutId : '0', listId: listId ? listId : '0' })
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { payoutId, listId } = nextProps;
		this.setState({ payoutId: payoutId ? payoutId : '0', listId: listId ? listId : '0' })
	}

	handleChange = (e) => {
		const { onChangeListingFilter, payoutId, listId } = this.props;
		if (e.target.name == 'listId') {
			onChangeListingFilter({ listId: e.target.value, payoutId });
		} else {
			onChangeListingFilter({ payoutId: e.target.value, listId });
		}

	}


	handleSubmit = async () => {
		const { handleResults, closeTransactionModal, listId, mode, payoutId } = this.props;
		await handleResults({ mode, listId, payoutId });
		await closeTransactionModal();
	}

	handleClear = async () => {
		const { onChangeListingFilter } = this.props;
		await onChangeListingFilter({ listId: null, payoutId: null });
	}

	render() {
		const { manageListingTransaction: { ManageListingTransaction }, getPayouts: { getPayouts } } = this.props;
		const { listId, payoutId } = this.state;
		const { formatMessage } = this.props.intl;
		const { locale, dynamicListTitle } = this.props;

		return (
			<div>
				<div className="oneColumnGrid">
					<FormGroup className={bt.noMargin}>
						<label className='commonLabelText'><FormattedMessage {...messages.filterByPayout} /></label>
						<FormControl
							componentClass="select"
							name='payoutId'
							className='commonSelectField'
							onChange={this.handleChange}
							value={payoutId}
						>
							<option value="0">{formatMessage(messages.allPayoutMethod)}</option>
							{
								getPayouts && getPayouts.map((item, index) => {
									if (item.paymentMethod.id === 2) {
										return (
											<option
												value={item.id}
												key={index}
											>
												******{item.last4Digits}
											</option>
										)
									} else {
										return (
											<option
												value={item.id}
												key={index}
											>
												{item.payEmail}
											</option>
										)
									}

								})

							}
						</FormControl>
					</FormGroup>
					<FormGroup className={bt.noMargin}>
						<label className='commonLabelText'><FormattedMessage {...messages.filterByCars} /></label>
						<FormControl name='listId' componentClass="select" className='commonSelectField' onChange={this.handleChange} value={listId}>
							<option value="0">{formatMessage(messages.allCars)}</option>
							{
								ManageListingTransaction && ManageListingTransaction.map((item, index) => {
									let dynamicTitle = getDynamicTitle({ data: dynamicListTitle, locale, id: item?.id });
									return (
										<option value={item.id} key={index}>{dynamicTitle ? dynamicTitle : item.title}</option>
									)
								})

							}
						</FormControl>
					</FormGroup>
				</div>
				<div className={cx('doubleBtnFlexEnd', bt.spaceTop4)}>
					<Button className={bt.btnPrimaryBorder}
						onClick={() => this.handleClear()}> {formatMessage(messages.clear)}</Button>
					<Button className={bt.btnPrimary} onClick={() => this.handleSubmit()}>
						<FormattedMessage {...messages.apply} />
					</Button>
				</div>

			</div>
		);
	}
}
const mapState = (state) => ({
	listId: state.onChangeListing.listId,
	payoutId: state.onChangeListing.payoutId,
	locale: state?.intl?.locale,
	dynamicListTitle: state?.dynamicListTitles?.data?.dynamicListTitle,
});

const mapDispatch = {
	onChangeListingFilter,
	closeTransactionModal
};

export default compose(
	connect(mapState, mapDispatch),
	injectIntl,
	withStyles(bt, s),
	withQuery(gql`
    	{
		    ManageListingTransaction {
		        id
                title
                isReady
            }
		}
    `,
		{
			name: 'manageListingTransaction',
			options: {
				ssr: false
			}
		}),
	withQuery(gql`
    	query getPayouts {
		  getPayouts {
		    id
		    methodId
		    paymentMethod{
		      id
		      name
		    }
		    userId
		    payEmail
		    address1
		    address2
		    city
		    state
		    country
		    zipcode
		    currency
		    default
		    createdAt
            status
            last4Digits
		  }
		}
    `,
		{
			name: 'getPayouts',
			options: {
				ssr: false
			}
		}),
)(Listings);